/* Elysian photo carousel (2026-09-30, sections/elysian-story.liquid). No autoplay: slides change only when a person asks.
   Dots, swipe or drag (pointer events), and arrow / Home / End keys while the carousel has focus. Stops at the ends. */
(function () {
  function init(root) {
    if (root.getAttribute('data-ely-carousel') === 'ready') return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('.ely-carousel__slide'));
    var dotsBox = root.querySelector('.ely-carousel__dots');
    var dots = dotsBox ? Array.prototype.slice.call(dotsBox.querySelectorAll('.ely-carousel__dot')) : [];
    var n = slides.length;
    if (n < 2) return;
    root.setAttribute('data-ely-carousel', 'ready');
    var current = 0;
    function go(k) {
      current = Math.max(0, Math.min(n - 1, k));
      slides.forEach(function (s, j) {
        var on = j === current;
        s.classList.toggle('is-active', on);
        if (on) { s.removeAttribute('aria-hidden'); } else { s.setAttribute('aria-hidden', 'true'); }
      });
      dots.forEach(function (d, j) {
        if (j === current) { d.setAttribute('aria-current', 'true'); } else { d.removeAttribute('aria-current'); }
      });
    }
    dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); }); });
    if (dotsBox) dotsBox.hidden = false;
    root.addEventListener('keydown', function (e) {
      var k = e.key;
      if (k === 'ArrowRight') { go(current + 1); } else if (k === 'ArrowLeft') { go(current - 1); }
      else if (k === 'Home') { go(0); } else if (k === 'End') { go(n - 1); } else { return; }
      e.preventDefault();
    });
    var sx = null, sy = 0;
    root.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      if (dotsBox && dotsBox.contains(e.target)) return;
      sx = e.clientX; sy = e.clientY;
    });
    root.addEventListener('pointerup', function (e) {
      if (sx === null) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      sx = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(current + (dx < 0 ? 1 : -1));
    });
    root.addEventListener('pointercancel', function () { sx = null; });
    go(0);
  }
  function all() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ely-carousel]'), init);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', all); } else { all(); }
  document.addEventListener('shopify:section:load', all);
})();
